import {
  isLocalDestinationOfferCarouselEnabled,
  shouldShowLocalDestinationOfferCarousel,
} from 'home/components/OfferCarousels/localDestinationOfferCarouselModel'

interface Options {
  isHotelFilter: boolean
  regionCode: string
}

export function useShowLocalDestinationOfferCarousel(options: Options): boolean {
  const { isHotelFilter, regionCode } = options
  const isEnabled = isLocalDestinationOfferCarouselEnabled(regionCode)

  return shouldShowLocalDestinationOfferCarousel({
    isHotelFilter,
    isEnabled,
  })
}
